import React from 'react'
import SummaryChargesDetails from './summary-charges-details';

export default function SummaryChargesDesktop(props) {
    const {charges, isExpanded, contentId, isMobileOrDesktop} = props;
    
    return (
        <div className='wth3-cssMainContent__rightCont' aria-hidden={isMobileOrDesktop ? 'true' : 'false'}>
            <div class="wth3-summaryCharges summaryChargesDesktop">
                <SummaryChargesDetails charges={charges} isExpanded={isExpanded} contentId={contentId} />
            </div>
        </div>
    )
}
